module.exports = __webpack_public_path__ + "static/img/GXwJ2P5C.6ea317fa.gif";